import makeStyles from '@mui/styles/makeStyles';
import { COLORS, FONT_18 } from 'constants/styles';

export default makeStyles(
  {
    root: {
      zIndex: 999999,
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      transform: 'translateY(100%)',
      transition: 'transform 0.25s linear',
      boxShadow: '0px -10px 50px rgba(0, 0, 0, 0.06)',
      backgroundColor: COLORS.white,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 16,
      ...FONT_18,

      '& > * + *': {
        marginLeft: 8,
      },

      '& > p': {
        marginTop: 4,
      },
    },
    rootVisible: {
      transform: 'translateY(0)',
    },
    success: {
      color: COLORS.success,
    },
    error: {
      color: COLORS.error,
    },
  },
  { name: 'Notification' },
);
